import router from './router'
import store from './store'
import NProgress from 'nprogress'
import 'nprogress/nprogress.css'
import { Message } from 'element-ui'
import { getToken } from '@/utils/auth'

const whiteList = ['/login']

function normalizePath(path) {
  if (!path) {
    return '/404'
  }
  return path.startsWith('/') ? path : `/${path}`
}

function joinPath(parentPath, childPath) {
  if (!childPath) {
    return normalizePath(parentPath)
  }
  if (childPath.startsWith('/')) {
    return childPath
  }
  if (!parentPath || parentPath === '') {
    return normalizePath(childPath)
  }
  return `${parentPath}/${childPath}`.replace(/\/+/g, '/')
}

function getFirstAccessibleRoute(routers, parentPath = '') {
  for (let i = 0; i < routers.length; i++) {
    const route = routers[i]
    if (route.hidden) continue
    const currentPath = route.path === '' ? parentPath : joinPath(parentPath, route.path)
    if (route.children && route.children.length > 0) {
      const childRoute = getFirstAccessibleRoute(route.children, currentPath)
      if (childRoute && childRoute !== '/404') {
        return childRoute
      }
    } else if (route.path) {
      return currentPath
    }
  }
  return '/404'
}

router.beforeEach((to, from, next) => {
  NProgress.start()
  if (getToken()) {
    if (to.path === '/login') {
      next({ path: '/' })
      NProgress.done()
    } else {
      if (store.getters.roles.length === 0) {
        store.dispatch('GetInfo').then(res => {
          const menus = res.data.menus
          const username = res.data.username
          const roles = res.data.roles || []
          store.dispatch('GenerateRoutes', { menus, username, roles }).then(() => {
            router.addRoutes(store.getters.addRouters)
            if (to.path === '/') {
              const firstRoute = getFirstAccessibleRoute(store.getters.addRouters)
              next({ path: firstRoute, replace: true })
            } else {
              next({ ...to, replace: true })
            }
          })
        }).catch((err) => {
          store.dispatch('FedLogOut').then(() => {
            Message.error(err || 'Verification failed, please login again')
            next({ path: '/' })
          })
        })
      } else {
        if (to.path === '/') {
          const firstRoute = getFirstAccessibleRoute(store.getters.addRouters)
          next({ path: firstRoute, replace: true })
        } else {
          next()
        }
      }
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      next()
    } else {
      next('/login')
      NProgress.done()
    }
  }
})

router.afterEach(() => {
  NProgress.done()
})



// WEBPACK FOOTER //
// ./src/permission.js